/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import {
  arrayOf, params, shape, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';
import {
  Heading, Col, Row
} from '@thd-olt-component-react/core-ui';
import { Tile } from '@thd-olt-component-react/tile';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { Faq } from '../Faq/Faq';
import { StoreDetailsContext } from '../StoreDetails.context';
import styles from './store-details-seo.module.scss';

const cx = classNames.bind(styles);

const StoreDetailsSEO = ({ className }) => {

  const { storeId } = useContext(StoreDetailsContext);
  const options = {
    variables: {
      storeId,
    }
  };
  const { data, loading, error } = useDataModel('seoStoreDetails', options);
  const seoContent = data?.seoStoreDetails?.[1];
  const content = seoContent?.content || {};
  const faq = seoContent?.faq || [];
  const iconObj = {
    position: 'left',
    size: 'sm'
  };
  if (loading) {
    return (
      <Tile shadow={false}>
        <LoadingPlaceholder
          color="#E0E0E0"
          rows={10}
          ready={false}
          style={{ height: '500px' }}
        >
          Loading...
        </LoadingPlaceholder>
      </Tile>
    );
  }
  if (!seoContent || error) return null;

  return (
    <div className={cx(className, 'pps-content')}>
      <Tile className={cx('pps-content__container')}>
        <Heading title={seoContent.header} underline />
        {content.map(({ text }, index) => {
          return (
            <Row key={index}>
              <Col>
                <div className={cx('pps-content__text')} dangerouslySetInnerHTML={{ __html: text }} />
              </Col>
            </Row>
          );
        })}
        <div className={cx('pps-content__question--wrapper')}>
          <Faq faq={faq} />
        </div>
      </Tile>
    </div>
  );
};

StoreDetailsSEO.propTypes = {
  className: string
};

StoreDetailsSEO.defaultProps = {
  className: null
};

StoreDetailsSEO.displayName = 'StoreDetailsSEO';

StoreDetailsSEO.dataModel = {
  seoStoreDetails: params({ storeId: stringType().isRequired() }).arrayOf(shape({
    header: stringType(),
    subHeader: stringType(),
    content: arrayOf(shape({
      text: stringType()
    })),
    faq: arrayOf(shape({
      question: stringType(),
      answer: stringType()
    }))
  }))
};

export { StoreDetailsSEO };
